import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import logo from "../assets/image/logo.png";
import PersonIcon from "@mui/icons-material/Person";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import PaymentIcon from "@mui/icons-material/Payment";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import KeyIcon from "@mui/icons-material/Key";
import ReportIcon from "@mui/icons-material/Report";
import SettingsIcon from "@mui/icons-material/Settings";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import CategoryIcon from "@mui/icons-material/Category";
import GroupAddIcon from "@mui/icons-material/GroupAdd";

function SideBar() {
  const [activeLink, setActiveLink] = useState("#");
  const [openDropdown, setOpenDropdown] = useState(""); // Manage the open state of each dropdown menu

  const menuItems = [
    { name: "Dashboard", path: "/dashboard", icon: <DashboardIcon /> },
    { name: "Take Order", path: "/take_order", icon: <AdUnitsIcon /> },
    {
      name: "Finance",
      path: "/finance",
      icon: <PaymentIcon />,
      subMenu: [
        {
          name: "Sales",
          path: "/sales",
          icon: <PaymentIcon fontSize="small" />,
        },
      ],
    },

    {
      name: "Master Action",
      path: "/Master_action",
      icon: <KeyIcon />,
      subMenu: [
        {
          name: "Tables",
          path: "/tables",
          icon: <TableRestaurantIcon fontSize="small" />,
        },
        {
          name: "Items",
          path: "/items",
          icon: <FastfoodIcon fontSize="small" />,
        },
        {
          name: "Items Category",
          path: "/category",
          icon: <CategoryIcon fontSize="small" />,
        },
      ],
    },
    // {
    //   name: "Reports",
    //   path: "/reports",
    //   icon: <ReportIcon />,
    //   subMenu: [],
    // },
    {
      name: "Settings",
      path: "/settings",
      icon: <SettingsIcon />,
      subMenu: [
        {
          name: "Users",
          path: "/users",
          icon: <GroupAddIcon fontSize="small" />,
        },
        {
          name: "Members",
          path: "/members",
          icon: <GroupAddIcon fontSize="small" />,
        },
      ],
    },
  ];
  const handleActiveLink = (link) => {
    setActiveLink(link);
  };

  const toggleDropdown = (path) => {
    setOpenDropdown(openDropdown === path ? "" : path); // Toggle the dropdown menu state
  };

  return (
    <>
      <ToastContainer
        className="toast-position"
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="SideBar">
        <div className="Logo">
          <img src={logo} alt="Logo" />
          POS System
        </div>
        <div className="UserBox">
          <PersonIcon />
          <div>
            <h4>Nyatapol</h4>
            <span>online</span>
          </div>
        </div>
        <div className="Menu">
          <ul>
            {menuItems.map((item) =>
              item.subMenu ? (
                <li
                  key={item.path}
                  className={activeLink.startsWith(item.path) ? "Active" : ""}
                  onClick={() => toggleDropdown(item.path)}
                >
                  <Link>
                    {item.icon} {item.name}
                    {/* {openDropdown === item.path ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )} */}
                  </Link>
                  {openDropdown === item.path && (
                    <ul className="SubMenu">
                      {item.subMenu.map((subItem) => (
                        <li
                          key={subItem.path}
                          className={
                            activeLink === subItem.path ? "Active" : ""
                          }
                          onClick={() => handleActiveLink(subItem.path)}
                        >
                          <Link to={subItem.path}>
                            {subItem.icon} {subItem.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ) : (
                <li
                  key={item.path}
                  className={activeLink === item.path ? "Active" : ""}
                  onClick={() => handleActiveLink(item.path)}
                >
                  <Link to={item.path}>
                    {item.icon} {item.name}
                  </Link>
                </li>
              )
            )}
          </ul>
        </div>
      </div>
    </>
  );
}

export default SideBar;
